import React from "react";
import style from '../Footer/Footer.module.css';

const Footer = () => {
  return (
    <div className={style.containerFooter}>
<div className={style.spacer}></div>
      <p>Derechos de autor © {new Date().getFullYear()} Rodriguez Nahuel</p>

      <div className={style.socialIcons}>
        <a
          href="https://www.instagram.com/nahueefrodriguez/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className={style.ig} src="https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Instagram_colored_svg_1-64.png" alt="Instagram" />
        </a>
        <a
          href="https://api.whatsapp.com/send?phone=3424403426"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="https://cdn2.iconfinder.com/data/icons/social-icons-color/512/whatsapp-512.png" alt="WhatsApp" />
        </a>
      </div>
    </div>
  );
};

export default Footer;
